import { useState } from "react";
import { Link } from "react-router-dom";
import { Question, ArrowLeft } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useImportGuides } from "@/lib/importGuides";
import { ImportGuideSteps } from "@/components/ImportGuideSteps";

// "Which app are you importing from?" → that app's step-by-step guide.
export function ImportGuidePicker({ label = "Step-by-step help for your app", testid = "import-guide-open" }) {
  const data = useImportGuides();
  const [key, setKey] = useState(null);
  const guide = data?.guides.find((g) => g.key === key);
  return (
    <Dialog onOpenChange={(o) => !o && setKey(null)}>
      <DialogTrigger asChild>
        <button type="button" data-testid={testid} className="inline-flex items-center gap-1 text-sm font-semibold text-rf-orange underline">
          <Question size={16} /> {label}
        </button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto z-[80]" data-testid="import-guide-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{guide ? `Importing from ${guide.label}` : "Which app are you importing from?"}</DialogTitle>
        </DialogHeader>
        {!guide ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="import-guide-app-list">
            {(data?.guides || []).map((g) => (
              <button key={g.key} type="button" onClick={() => setKey(g.key)} data-testid={`import-guide-app-${g.key}`}
                      className="text-left text-sm font-semibold rounded-xl border border-slate-200 px-3 py-2 hover:border-rf-orange hover:bg-amber-50">
                {g.label}
              </button>
            ))}
          </div>
        ) : (
          <>
            <button type="button" onClick={() => setKey(null)} className="text-sm font-semibold text-slate-600 inline-flex items-center gap-1 w-fit" data-testid="import-guide-back">
              <ArrowLeft size={14} /> All apps
            </button>
            <ImportGuideSteps guide={guide} common={data.common} />
            <Link to={guide.own_page || `/help/import/${guide.key}`} className="text-sm font-semibold text-rf-orange underline" data-testid="import-guide-full-page">
              Open this guide as a page to share or bookmark
            </Link>
          </>
        )}
        <Link to="/help/import" className="text-xs font-semibold text-slate-500 underline" data-testid="import-guide-hub-link">See every import guide</Link>
      </DialogContent>
    </Dialog>
  );
}
